/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex-schema'

const $nsid = 'com.atproto.repo.listRecords'

export { $nsid }

export const $params = /*#__PURE__*/ l.params({
  repo: /*#__PURE__*/ l.string({ format: 'at-identifier' }),
  collection: /*#__PURE__*/ l.string({ format: 'nsid' }),
  limit: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.withDefault(
      /*#__PURE__*/ l.integer({ minimum: 1, maximum: 100 }),
      50,
    ),
  ),
  cursor: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
  reverse: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.boolean()),
})

export type $Params = l.InferOutput<typeof $params>

export const $output = /*#__PURE__*/ l.jsonPayload({
  cursor: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
  records: /*#__PURE__*/ l.array(
    /*#__PURE__*/ l.ref<Record$0>((() => record$0) as any),
  ),
})

export type $Output<B = l.BinaryData> = l.InferPayload<typeof $output, B>
export type $OutputBody<B = l.BinaryData> = l.InferPayloadBody<
  typeof $output,
  B
>

/** List a range of records in a repository, matching a specific collection. Does not require auth. */
const main = /*#__PURE__*/ l.query($nsid, $params, $output)

export { main }

export const $lxm = $nsid

type Record$0 = {
  $type?: 'com.atproto.repo.listRecords#record'
  uri: l.AtUriString
  cid: l.CidString
  value: l.LexMap
}

export type { Record$0 as Record }

const record$0 = /*#__PURE__*/ l.typedObject<Record$0>(
  $nsid,
  'record',
  /*#__PURE__*/ l.object({
    uri: /*#__PURE__*/ l.string({ format: 'at-uri' }),
    cid: /*#__PURE__*/ l.string({ format: 'cid' }),
    value: /*#__PURE__*/ l.lexMap(),
  }),
)

export { record$0 as record }
